import React from 'react'
import { toaster } from 'rsuite'

interface ToastOptions {
  placement?:
    | 'topStart'
    | 'topCenter'
    | 'topEnd'
    | 'bottomStart'
    | 'bottomCenter'
    | 'bottomEnd'
  duration?: number
  [key: string]: any
}

interface UseStandardToasterReturn {
  pushToast: (content: React.ReactNode, options?: ToastOptions) => void
}

/**
 * Custom hook that overrides the default RS Suite toaster positioning
 * Moves toast notifications to a custom position on the page
 */
const useStandardToaster = (): UseStandardToasterReturn => {
  // Create and inject styles for RS Suite toast container
  React.useEffect(() => {
    const styleElement = document.createElement('style')

    styleElement.textContent = `
      .rs-toast-container {
        top: 115px !important;
        left: 20% !important;
      }
      .rs-toast-container.placement-top-center {
        transform: translateX(-50%) !important;
      }
    `
    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  const pushToast = (
    content: React.ReactNode,
    options: ToastOptions = {},
  ): void => {
    toaster.push(content, { placement: 'topCenter', ...options })
  }

  return { pushToast }
}

export default useStandardToaster
